export default __webpack_public_path__ + "35f324311ceeec250e339de88d0fedca.png";